<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Editar Género</h5>
        </div>        
        <emt-form ref="unit-form" v-bind:resource="config.api + '/gender/'" v-bind:items="itemsForm" v-bind:updateData="update"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'

export default{
    name: 'emt-form-edit-gender',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Nombre',
                    'placeholder': 'Ingrese nombre de género',
                    'value': null,
                    'maxlength': '20',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }
            ],
            config: Config,
            update: true
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getData(Config.api + '/gender/')
    },
    methods: {
        getData: function (url) {
            url = `${url}${this.$route.params.id}/`
            let self = this
            self.$http.get(url).then(function (response) {
                self.setValue(response.body)
            }, function (response) {
            })
        },
        setValue: function (value) {
            for (var form in this.itemsForm) {
                this.itemsForm[form].value = value[this.itemsForm[form].name]
            }
        }
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-edit-gender.vue?67753676